import React, {Component} from 'react'
import CustomFieldDefinitionEditForm from "./form/edit.component.jsx"
import SideBar from '../common/layout/sidebar.component.jsx'

class CustomFieldDefinitionNew extends Component {

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
    }

    render() {
        return (
            <div>
                <CustomFieldDefinitionEditForm />
            </div>
        );
    }
}

export default CustomFieldDefinitionNew


// WEBPACK FOOTER //
// ./src/custom-field/new.component.jsx